module.exports = __webpack_public_path__ + "static/media/pk.f7695293.svg";